<template>
    <div>

        <loading />
        <header-cna />

        <div class="container pb-5">
            <div class="criar-conta mt-5">
                <h2 class="text-center">
                    <strong>Recuperar Senha</strong>
                </h2>

                <div class="dados-conta bg-white mt-3 rounded py-5 px-3 p-md-5 shadow">
                    <form class="form cf">
                        <div class="row" v-if="step == 1">
                            <div class="col-12 mb-3">
                                <label for="email">Informe seu username ou CPF/CNPJ utilizado para acesso.</label>
                                <input type="text" class="form-control" placeholder="Username ou CPF/CNPJ (somente números)" name="userName" autocomplete="off" v-model="model.login" required />
                                <small id="emailHelp" class="form-text text-muted">Será enviado um e-mail com um link para recuperação da senha.</small>
                            </div>
                        </div>
                        <div class="row" v-if="step == 2 && result">
                            <div class="col-12 mb-3">
                                <div class="row">
                                    <strong>Olá {{result.nome}}, </strong>
                                    <small id="nomeHelp" class="form-text text-muted">Clique em continuar para que seja enviado um link para alterar sua senha.</small>
                                </div>
                                <div class="row mt-3">
                                    <span>Será enviado um email para <strong>{{ result.login }}</strong></span>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="step == 3">
                            <div class="alert alert-success col-12 mb-3">
                                <i class="far fa-check-circle"></i>
                                <strong class="text-primary"> E-mail enviado com sucesso. <br />Por favor verifique sua caixa de entrada ou spam!</strong>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-6 ">
                                <button type="button" class="btn btn-light border-primary rounded-pill previous-button px-4" @click="sendBack()">Voltar</button>
                            </div>
                            <div class="col-6 text-right" v-if="step != 3">
                                <button type="button" class="btn btn-primary bg-azul-escuro rounded-pill enviar-codigo px-4" @click="mudaPasso(step)">Continuar</button>
                            </div>
                        </div>
                    </form>
                </div>

            </div>
        </div>

    </div>

</template>



<script>
    import base from '@/common/base.js'
    import Global from '@/common/global'
    import { Api } from '@/common/api'

    import loading from '@/common/components/loading'
    import headerCna from '@/template/header'

    export default {
        name: 'esqueci-senha',
        mixins: [base],
        components: {
            headerCna,
            loading,
        },
        data: () => ({

            step: 1,
            model: {},
            result: {}

        }),
        methods: {
            mudaPasso(step) {
                switch (step) {
                    case 1:
                        this.buscarPorPessoa();
                        break;
                    case 2:
                        this.enviarEmailRecuperacaoSenha();
                        break;
                    default:
                }
            },
            buscarPorPessoa() {
                this.showLoading();
                new Api('pessoacnaacesso/BuscarUsuarioPorTipoAcesso').get(this.model).then(result => {
                    this.step = 2;
                    this.result = result.data;
                    this.hideLoading();
                }, err => {
                    this.defaultErrorResult(err, true);
                })
            },
            enviarEmailRecuperacaoSenha() {
                this.showLoading();
                new Api('pessoacnaacesso/EnviarEmailRecuperacaoSenha').get(this.result).then(result => {
                    this.step = 3;
                    this.defaultSuccessResult("E-mail enviado com sucesso! Verifique sua caixa de entrada!");
                    this.hideLoading();
                }, err => {
                    this.defaultErrorResult(err, true);
                })
            },
            sendBack() {
                if (this.step == 2)
                    this.step--;
                else
                    history.back();
            }
        },

        mounted() {

        }
    };
</script>
